
<section class="breadcrumb-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-title">
            <h1>TM Express</h1>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-lg std-scholarship">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="inner-title"  >
            <h4>TM Express</h4>
           
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <div class="pdf-box">
              <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
              </div>
              <h5>UTSAV 2023</h5>            
              <a class="button-text" href="https://drive.google.com/file/d/1SC2Z5R16a_6qSUrG1E4AYUBagjVvc9qp/view?usp=sharing" target="_blank">Read More</a>
          </div>
        </div>

        <div class="col-md-4 col-lg-3">
          <div class="pdf-box">
              <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
              </div>
              <h5>Newsletter - September 2022</h5>            
              <a class="button-text" href="https://drive.google.com/file/d/10RckYzxCfMM34V4jtjzKy2-njJjI1VEK/view?usp=sharing" target="_blank">Read More</a>
          </div>
        </div>

        <div class="col-md-4 col-lg-3">
          <div class="pdf-box">
              <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
              </div>
              <h5>Cynosure 2022-23</h5>            
              <a class="button-text" href="https://drive.google.com/file/d/1akSWW_-SMS5rbk7wgTEkl9fv9E1BRTvL/view?usp=sharing" target="_blank">Read More</a>
          </div>
        </div>

        <div class="col-md-4 col-lg-3">
          <div class="pdf-box">
              <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
              </div>
              <h5>Toastmasters General Council 2022-23</h5>            
              <a class="button-text" href="https://drive.google.com/file/d/17YFVJ9PxwqTNLd6C7e0ta7EdzABkvG37/view?usp=sharing" target="_blank">Read More</a>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <div class="pdf-box mt-5">
              <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
              </div>
              <h5>Public speaking and Storytelling Workshop</h5>            
              <a class="button-text" href="https://drive.google.com/file/d/17SGXWWCgwCuc75KCjoAjdW4jAHVrSz_E/view?usp=sharing" target="_blank">Read More</a>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
            <div class="pdf-box mt-5">
                <div class="pdf-icon">
                    <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <h5>Newsletter-April 2022</h5>            
                <a class="button-text" href="https://drive.google.com/file/d/1HLlA6iSgiH8oLfPnW19apt-ochtvPY3u/view?usp=sharing" target="_blank">Read More</a>
            </div>
          </div>
          <div class="col-md-4 col-lg-3">
            <div class="pdf-box mt-5">
                <div class="pdf-icon">
                    <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <h5>Newsletter-March 2022</h5>            
                <a class="button-text" href="https://drive.google.com/file/d/1lgTV2DCUuAHAzzRdAt6qFVVgWw6XbCLW/view?usp=sharing" target="_blank">Read More</a>
            </div>
          </div>
      </div>
    </div>
  </section>
  